/**
 * 일정 투표의 항목 표기 (chat-polls — 2026-08-26).
 *
 * 달력에서 고른 날짜(`2026-09-04`)를 **사람이 읽는 한 가지 표기**로 바꾼다. 손으로 적게 두면
 * "9/4", "9월4일", "다음주 목요일" 처럼 사람마다 달라져 같은 날이 두 항목이 된다.
 *
 * 서버는 항목을 글자로만 다루므로(종류를 모른다) 여기서 바꿔 담으면 저장·집계가 그대로 돈다.
 */

const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'] as const;

/**
 * `2026-09-04` → `9월 4일 (목)`. 날짜로 못 읽으면 **원문을 그대로** 돌려준다
 * (빈 칸이나 손으로 적은 값이 사라지지 않게).
 *
 * ⚠ `new Date('2026-09-04')` 는 **UTC 자정**으로 읽혀 시간대에 따라 하루가 밀린다.
 *   그래서 숫자를 직접 갈라 그 지역 날짜로 만든다.
 */
export function formatPollDate(value: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!m) return value;
  const [, y, mo, d] = m;
  const date = new Date(Number(y), Number(mo) - 1, Number(d));
  if (Number.isNaN(date.getTime())) return value;
  // 달·날이 되돌아오지 않으면(2026-02-31 같은 값) 날짜가 아니다.
  if (date.getMonth() !== Number(mo) - 1 || date.getDate() !== Number(d)) return value;
  return `${date.getMonth() + 1}월 ${date.getDate()}일 (${WEEKDAYS[date.getDay()]})`;
}
